'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['card', 'header', 'notice', 'overdue', 'date', 'icon', 'body', 'content', 'footer'];
var headerNoticeStyles = {
  ml: 'auto',
  pl: 1,
  display: 'flex',
  alignItems: 'center'
};
var baseStyle = function baseStyle(props) {
  var isSelected = props.isSelected,
    isElevated = props.isElevated;
  return {
    card: {
      layerStyle: 'card',
      px: 3,
      py: 1,
      bg: isSelected ? 'blue.200' : 'white',
      boxShadow: isElevated ? 'md' : 'sm',
      color: 'gray.400'
    },
    header: {
      fontSize: 'sm',
      pb: 1,
      display: 'flex',
      alignItems: 'center'
    },
    notice: headerNoticeStyles,
    overdue: _objectSpread(_objectSpread({}, headerNoticeStyles), {}, {
      fontWeight: 'semibold',
      color: 'red.400'
    }),
    date: _objectSpread(_objectSpread({}, headerNoticeStyles), {}, {
      color: 'blue.400'
    }),
    body: {
      pt: 1,
      pb: 2,
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      boxSize: '56px'
    },
    content: {
      pl: 3,
      '& *:first-of-type': {
        fontWeight: 'semibold',
        mb: 0.5,
        color: 'gray.600'
      }
    },
    footer: {
      fontSize: 'sm',
      pt: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderTop: '1px',
      borderTopColor: 'gray.300',
      minHeight: '28px'
    }
  };
};
var BrokerLeadCard = {
  parts: parts,
  baseStyle: baseStyle
};
exports["default"] = BrokerLeadCard;